module.exports = __webpack_public_path__ + "static/media/pic_empty_lock.05df8fc6.png";